module.exports = __webpack_public_path__ + "static/strategic_planing_pyramind-a15b6cb7e821befb69543afefdc930e8.png";